module.exports = __webpack_public_path__ + "img/persona2.2f71616c.png";